// Página Configurações (M11): vincular/desvincular MP + histórico de créditos.
// Acessada via submenu Financeiro → Configurações.
import React, { useCallback, useEffect, useState } from 'react';
import { Typography, Space, Card, message } from 'antd';
import { SettingOutlined, DollarOutlined, HistoryOutlined } from '@ant-design/icons';
import api from '../../../services/api';
import { getActiveTeamId } from '../../../utils/activeTeam';
import MpConnectionCardCommunity from './MpConnectionCardCommunity';
import CreditsHistoryTable from './CreditsHistoryTable';

const { Title, Text } = Typography;

export default function FinanceSettingsPage() {
  const teamId = getActiveTeamId();
  const [mpStatus, setMpStatus] = useState({ connected: false });

  const loadMp = useCallback(async () => {
    if (!teamId) return;
    try {
      const r = await api.get('/community/finance/mp-connection/status', { params: { team_id: teamId } });
      setMpStatus(r.data);
    } catch (e) { message.error('Falhou verificar MP'); }
  }, [teamId]);
  useEffect(() => { loadMp(); }, [loadMp]);

  if (!teamId) return <div style={{ padding: 32, textAlign: 'center' }}>Escolha um time no seletor.</div>;

  return (
    <div style={{ padding: '16px 12px', maxWidth: 1200, margin: '0 auto' }}>
      <Title level={4} style={{ marginTop: 0, marginBottom: 16 }}>
        <Space><SettingOutlined /> Configurações</Space>
      </Title>

      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Card size="small" title={<Space><DollarOutlined /><Text strong>Conta Mercado Pago</Text></Space>}>
          <MpConnectionCardCommunity
            communityTeamId={teamId}
            providerStatus={mpStatus}
            onStatusChange={loadMp}
          />
        </Card>

        <Card size="small" title={<Space><HistoryOutlined /><Text strong>Histórico de créditos</Text></Space>}
          styles={{ body: { padding: 0 } }}>
          <CreditsHistoryTable communityTeamId={teamId} />
        </Card>
      </Space>
    </div>
  );
}
